import { HypeCard } from "../../components/hypeCard/HypeCard";
import { useLocale } from "../../services/DataContext";

export interface IHype {
  name: string;
  difference: number,
  metaCritic: number,
  hypeScore: number,
  rank: number,
  releaseScore: number
}


export interface HypesProps {
  data: IHype[]
}


export const Hypes: React.FC<HypesProps> = ({ data }) => {
  const l: any = useLocale();
  return <div className="hype container">
    <TopSideContent
      title={l["hypeTitle"]}
      description={l["hypeDescription"]}
    />
    <div className="hype__header animate__animated animate__fadeIn">
      <div className="hype__col hype__col--rank">
        <p className="text-uppercase">
          {l["rank"]}
        </p>
      </div>
      <div className="hype__col hype__col--title">
        <p className="text-uppercase">
          {l["title"]}
        </p>
      </div>
      <div className="hype__col hype__col--diff">
        <p className="text-uppercase">
          {l["difference"]}
        </p>
      </div>
    </div>
    {
      data.map((e, i) => <HypeCard
        className={`animate__animated animate__fadeIn delay-${i} `}
        key={e.rank}
        item={e} />)
    }
  </div>
}

export interface TopSideContentProps {
  title: string;
  description: string;
}

export const TopSideContent: React.FC<TopSideContentProps> = (props) => {
  return <>
    {/* <div className="row hide-on-medium">
      <div className="col mb-1">
        <div className="hype__client-logo animate__animated animate__fadeIn">
          <img src={ClientLogoHor} alt="" />
        </div>
      </div>
      <div className="col mb-1">
        <div className="hype__campaign-logo animate__animated animate__fadeIn">
          <img src={CampaignLogoHor} alt="" />
        </div>
      </div>
    </div> */}
    <div className="row">
      <div className="col hype__content animate__animated animate__fadeIn">
        <h1 className="hide-on-medium text-uppercase mb-1">{props.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: props.description }} className="hype__description font-bold mb-1"></div>
      </div>
    </div>
  </>
}